import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ShowDetails from './show-details';
import AstrologyTeeup from './teeup';
import YourBirthChart from './your-birth-chart';
import { smoothScrollToElement } from '../../shared/scroll';
import { nl2br } from '../../shared/util';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if(nextProps.report != this.props.report) {
            return true;
        }

        return false;
    }

    render({ product }) {
        if (product && product.description && product.description.code) {
            return (
                <product-teeup>
                    {this.renderImage()}
                    {this.renderMessage()}
                    {this.renderH1()}
                    {this.renderDetails()}
                    {this.renderTeeup()}
                    {this.renderContent()}
                </product-teeup>
            );
        }

        return (<product-teeup />);
    }

    renderImage = () => {
        if (this.props.product.description.code == 'free-birth-chart-redux' && this.props.report) {
            return null;
        }

        const url = this.props.product.description.code == 'free-birth-chart-redux'
            ? 'https://gfx.tarot.com/images/navigation/icons/wheel.svg'
            : `https://gfx.tarot.com/images/products/${this.props.product.description.slug}/icon.svg`;

        return (
            <img
                className='product-logo'
                alt={this.props.product.description.product_name}
                src={url}
            />
        );
    }

    renderH1 = () => {
        if (this.props.product.description.code != 'free-birth-chart-redux') {
            return (<h1 className='has-text-center'>{this.props.product.description.product_name}</h1>);
        }

        return null;
    }

    renderMessage = () => {
        if (this.props.message) {
            return (<h2 className='has-text-center'>{this.props.message}</h2>);
        }

        return null;
    }

    renderDetails = () => {
        if (this.props.product.description.code != 'free-birth-chart-redux') {
            if (this.props.showContent) {
                return (<p className='has-text-center'>{this.props.product.description.subheader}</p>);
            }

            return (
                <ShowDetails
                    summary={this.props.product.description.subheader}
                    details={this.props.product.description.long_description}
                />
            );
        }

        return null;
    }

    renderTeeup = () => {
        if (this.props.product.description.code == 'free-birth-chart-redux') {
            return (<YourBirthChart />);
        }

        return (<AstrologyTeeup />);
    }

    renderContent = () => {
        if (this.props.showContent) {
            return (
                <div className='has-margin-50-top'>
                    {this.renderH2()}
                    <p dangerouslySetInnerHTML={{ __html: nl2br(this.props.product.description.long_description) }} />
                    <row className='is-justified-center has-margin-30-top'>
                        <column>
                            <a href='' className='button' onClick={(e) => this.goTo(e, 'main')}>
                                START MY REPORT
                            </a>
                        </column>
                    </row>
                </div>
            );
        }

        return null;
    }

    renderH2 = () => {
        return (
            ['essential-birth-sample', 'essential-birth-report-redux'].includes(this.props.product.description.code)
                ? <h2 className='has-margin-25-bottom'>What is a birth chart?</h2>
                : <h2 className='has-margin-25-bottom'>About This {this.props.product.description.product_name}</h2>
        );
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        this.trackClick();
        smoothScrollToElement(document.querySelector(chapter));
    }

    trackClick = () => {
        if (this.props.showContent) {
            this.props.trackEvent([
                'Readings',
                'Click',
                `${this.props.upc}:StartMyReport`,
                `Readings_${this.props.upc}:StartMyReport`,
            ]);
        }
    }
}

const mapStateToProps = (state) => ({
    product: state.product,
    report: state.report,
    upc: state.product && state.product.description && state.product.description.code,
    showContent: state.product && state.product.description && state.product.description.code &&
        ['essential-birth-sample', 'essential-birth-report-redux', 'astrology-compatibility-sample']
            .includes(state.product.description.code),
});
const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
